// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"l1-z","subtitle":"m1-z","wrapper":"n1-z","leftArrow":"o1-z","rightArrow":"p1-z"};